import { Injectable }                        from "@angular/core";
import { Response }                          from "@angular/http";
import { CONFIGURATION }                     from "../../../app.constants";
import { USERHOMECONSTANTS }                 from "../userHome.constants";
import { Pagination }                  from "../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../services/shared";

@Injectable()
export class MessagesService {

    constructor(private httpData: HttpDataService) { }

    public SearchMessages(pagination: Pagination, sortOrder: string, sortColumn: string, includeRead: boolean): Observable<Response> {
        let filter = "";
        if (includeRead === false) {
            filter = `&$filter=MessageStatusCode eq '${USERHOMECONSTANTS.messageStatus.unread}'`;
        }
        let order: string = "&$orderby=" + sortColumn + " " + sortOrder;
        let skip: any = (pagination.currentPage - 1) * pagination.itemsPerPage;
        let top: any = pagination.itemsPerPage;

        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}message/search?$skip=${skip}&$top=${top}${order}&$count=true${filter}`;
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/messages/messages.service.ts